const namespaced = true;

const state = {
  appPage: 'app-screen-splash',
  activeModal: 0,
};

const getters = {
  getAppPage: (state) => state.appPage,
  getActiveModal: (state) => state.activeModal,
};

const mutations = {
  setAppPage: (state, payload) => {
    state.appPage = payload;
  },
  setActiveModal: (state, payload) => {
    state.activeModal = payload;
  },
};

const actions = {
  screenSplashNext: ({ commit }) => {
    commit('setAppPage', 'app-screen-laser-use');
  },
  screenLaserUseNext: ({
    dispatch,
    commit,
    rootState,
    rootGetters,
  }) => {
    if (rootState.laserUse.possibleAnswers.distance
      .indexOf(rootState.laserUse.distance) === -1) {
      commit('setError', rootState.text['0010'], { root: true });
    }
    if (rootState.laserUse.possibleAnswers.inOrOut
      .indexOf(rootState.laserUse.inOrOut) === -1) {
      commit('setError', rootState.text['0011'], { root: true });
    }
    if (rootGetters['laserUse/isCompleted']) {
      commit('setAppPage', 'app-screen-category');
      window.scrollTo(0, 0);
      // only fetch applications
      // if they haven't been fetched before (which means currentType = 0)
      // or if the type has changed
      if (rootGetters['laserUse/getType'] !== rootGetters['application/getCurrentType']) {
        dispatch(
          'application/fetchApplications',
          { lang: rootState.language, type: rootGetters['laserUse/getType'] },
          { root: true },
        );
      }
    }
  },
  screenLaserUsePrevious: ({ commit }) => {
    commit('setAppPage', 'app-screen-splash');
    window.scrollTo(0, 0);
  },
  screenCategoryNext: (context) => {
    if (context.rootGetters['application/getCategorySelection'] === 0) {
      // no categories selected
      context.commit('setError', context.rootState.text['0014'], { root: true });
    } else {
      context.commit('setAppPage', 'app-screen-application');
      window.scrollTo(0, 0);
      context.commit(
        'application/setCurrentCategory',
        context.rootGetters['application/getFirstCategory'],
        { root: true },
      );
    }
  },
  screenCategoryPrevious: ({ commit }) => {
    commit('setAppPage', 'app-screen-laser-use');
    window.scrollTo(0, 0);
  },
  screenApplicationNext: (context) => {
    if (context.rootGetters['application/getApplicationSelection'] === 0) {
      // no applications selected
      context.commit('setError', context.rootState.text['0016'], { root: true });
    } else if (context.rootGetters['application/getNextCategory'] !== 0) {
      // this category is filled, go to the next one
      context.commit(
        'application/setCurrentCategory',
        context.rootGetters['application/getNextCategory'],
        { root: true },
      );
    } else if (context.rootGetters['application/getNextEmptyCategory'] !== 0) {
      // this category is filled, go to the next empty one
      context.commit(
        'application/setCurrentCategory',
        context.rootGetters['application/getNextEmptyCategory'],
        { root: true },
      );
    } else {
      // all categories filled, next page
      context.commit('setAppPage', 'app-screen-result');
      window.scrollTo(0, 0);
      const input = {
        data: context.rootGetters['application/getApplications'],
        lang: context.rootGetters.getLanguage,
      };
      context.dispatch('fetchResult', input, { root: true });
    }
  },
  screenApplicationPrevious: ({ commit }) => {
    commit('setAppPage', 'app-screen-category');
  },
  screenResultModify: ({ commit }) => {
    window.scrollTo(0, 0);
    commit('setAppPage', 'app-screen-laser-use');
  },
  screenResultNew: ({ commit, dispatch }) => {
    dispatch(
      'laserUse/resetLaserUse',
      null,
      { root: true },
    );
    dispatch(
      'application/resetApplications',
      null,
      { root: true },
    );
    window.scrollTo(0, 0);
    commit('setAppPage', 'app-screen-laser-use');
  },
  screenEmail: ({ commit }) => {
    commit('setActiveModal', 1);
  },
  closeModal: ({ commit }) => {
    commit('setActiveModal', 0);
    commit('setEmailFormSentStatus', 0, { root: true });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js